@let isRMMPE = permissionsEnum.RmmPerEndpoint | can: 'read';
@let isRMMCE = permissionsEnum.RmmCeEnabled | can: 'read';
@let hasHelpMarketing = 'HelpMarketing' | can: 'read';
@let canShowConnect = (permissionsEnum.ShowRemoteConnection | can: 'read') || isInternal;
@let canShowRmm = (permissionsEnum.Rmm | can: 'read') || isInternal;
@let canShowBackup = (permissionsEnum.Backup | can: 'read') || isInternal;

<form [formGroup]="wizardForm">
  <mbs-input-label
    [label]="'shared:computers.addComputerWizard.actionStep.productLabel' | i18next"
    [labelClasses]="'fw-bold'"></mbs-input-label>
  <div class="row">
    @for (data of tilesConfig; track $index; let index = $index) {
      @if (
        (data.id !== agentType.RA || canShowConnect) &&
        (data.id !== agentType.RMM || canShowRmm) &&
        (data.id !== agentType.Backup || canShowBackup)
      ) {
        <div class="col-4">
          <button
            class="app-add-computer-wizard_tile"
            [class.-selected]="data.id === agentTypeControl.value"
            (click)="agentTypeControl.patchValue(data.id)">
            <div class="d-flex mx-3 my-3">
              <div class="mr-3">
                <span [class]="data.icon"></span>
              </div>
              <div class="flex-grow-1 d-flex flex-column align-items-start">
                <div class="text-lg fw-bold">{{ data.title }}</div>
                <div class="text-start text-sm text-muted">{{ data.description }}</div>
              </div>
            </div>
          </button>
        </div>
      }
    }
  </div>

  @if (!isRMMPE && isRMMCE && agentTypeControl?.value === agentType.RMM) {
    <div class="row mt-3">
      <div class="col-12">
        @if (limitRMMCEExceeded$ | async) {
          @let canBuy = permissionsEnum.LicenseBuy | can: 'read';

          <mbs-alert
            class="mb-0 mt-3"
            [icon]="true"
            [type]="mbsPopupType.danger">
            @if (canBuy) {
              <div>
                {{ 'shared:computers.addComputerWizard.actionStep.rmmCeLimitExceededAlert' | i18next }}
              </div>
              <div>
                <mbs-button
                  type="primary"
                  [isCtrl]="true"
                  [size]="size.md"
                  (click)="selectLicenseAfterRMMCE()">
                  @if (isPostPayment$ | async) {
                    {{ 'shared:computers.license.assignLicense' | i18next }}
                  } @else {
                    {{ 'shared:computers.license.buyLicense' | i18next }}
                  }
                </mbs-button>
              </div>
            } @else {
              <div>
                {{ 'shared:computers.addComputerWizard.actionStep.rmmCeLimitExceededAlertNoAccess' | i18next }}
              </div>
            }
          </mbs-alert>
        } @else {
          {{ RMMCEInfo }}
          @if (hasHelpMarketing) {
            <mbs-button
              type="primary"
              [isCtrl]="true"
              [size]="size.lmd"
              (click)="openRMMCEHelpPage()">
              {{ 'shared:buttons.learnMore' | i18next }}
            </mbs-button>
          }
        }
      </div>
    </div>
  }

  <div class="row mt-3">
    <div class="col-6">
      <mbs-select
        formControlName="os"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [clearable]="false"
        [items]="availableOsTypes"
        [label]="'shared:computers.addComputerWizard.actionStep.platform' | i18next"
        [labelClasses]="'fw-bold'"
        [showRequiredMark]="false"></mbs-select>
    </div>

    <div class="col-6">
      <mbs-select
        bindLabel="name"
        bindValue="id"
        formControlName="companyId"
        [items]="companies$ | async"
        [label]="'shared:common.company' | i18next: { format: 'title' }"
        [labelClasses]="'fw-bold'">
        @if ((permissionsEnum.ManageCompanies | can: 'read') && (permissionsEnum.AccessToAllCompanies | can: 'read')) {
          <ng-template #mbsSelectFooterTmp>
            <mbs-button
              [isCtrl]="true"
              (click)="onAddCompanyButtonClick()">
              {{ 'shared:computers.addNewCompany' | i18next }}
            </mbs-button>
          </ng-template>
        }
      </mbs-select>
    </div>
  </div>

  @if (showCompanyUnsupportedAlert && wizardForm.value?.companyId) {
    <div class="row mt-3">
      <div class="col-12">
        <mbs-alert [icon]="true">{{ 'shared:computers.addComputerWizard.actionStep.companyUnsupportedAlert' | i18next }}</mbs-alert>
      </div>
    </div>
  }
</form>
